import Swiper, { A11y, Navigation } from 'swiper';

class mStoreLocatorSlider extends HTMLDivElement {
    constructor() {
        super();
        this.slider = null;
        this.sliderInitialised = false;
    }

    connectedCallback() {
        this.initSlider();
    }

    initSlider() {
        this.slider = new Swiper(this, {
            modules: [A11y, Navigation],
            slidesPerView: 'auto',
            spaceBetween: 22,
            breakpoints: {
                360: {
                    slidesPerView: 1.3
                },
                480: {
                    slidesPerView: 1.3
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 32
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            },
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            grabCursor: true,
            a11y: {
                prevSlideMessage: this.dataset.a11ySlidePrev,
                nextSlideMessage: this.dataset.a11ySlideNext
            }
        });
        this.sliderInitialised = true;
    }
}

customElements.define('m-store-locator-slider', mStoreLocatorSlider, {
    extends: 'div'
});
